module.exports = __webpack_public_path__ + "static/img/slide_3.5a18efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/slide_3.png
// module id = fGax
// module chunks = 0